module.exports = __webpack_public_path__ + "static/img/monitor01.cbbc07c5.png";